import { FormattedMessage } from 'react-intl';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { TranslationKeys } from '@/lib/translations/types';

interface FilterSelectProps {
  id: string;
  label: TranslationKeys;
  value: string;
  onValueChange: (value: string) => void;
  options: Array<{ value: string; labelId: TranslationKeys }>;
}

export const FilterSelect = ({
  id,
  label,
  value,
  onValueChange,
  options,
}: FilterSelectProps): JSX.Element => (
  <div>
    <label
      htmlFor={id}
      className="text-xs font-medium text-gray-700 dark:text-gray-300 mb-2 block"
    >
      <FormattedMessage id={label} />
    </label>
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="w-full">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map(option => (
          <SelectItem key={option.value} value={option.value}>
            <FormattedMessage id={option.labelId} />
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
